const { getElementMenuId } = require('../context-menu');

const PopupMenuButtons = require('./content/popupmenu-buttons');
const template = require('./template.hbs');

module.exports = Backbone.View.extend({
  popupMenuButtons: null,

  initialize: function () {
    _.bindAll(this, 'hide', 'removeElementEvent');

    this.popupMenuButtons = new PopupMenuButtons();
    INKIVE.DesignFacade.on('delete', this.removeElementEvent);
  },

  render: function (elems, menuId) {
    if (this.canvas && this.canvas.runExtensions('getBleedValues', {}).manage && menuId !== 'bleed') {
      return;
    }
    if (!elems || !elems.length) {
      return;
    }
    this.$el.html() || this.$el.html(template());
    this.hide();

    // Individual menu ids that make the current menu multiselect; e.g. ['image', 'text']
    const multiselectMenuIds = [];
    if (!menuId) {
      for (let i = 0; i < elems.length; i++) {
        const elem = elems[i];
        if (!elem) { continue; }
        $(elem).hasClass('element') || $(elem).addClass('element');
        const elementMenuId = getElementMenuId(elem);
        if (i === 0) {
          menuId = elementMenuId;
          multiselectMenuIds.push(menuId);
        }
        if (i > 0 && elementMenuId !== menuId) {
          menuId = 'multiselect';
          multiselectMenuIds.push(elementMenuId);
          break;
        }
      }
    }

    this.show(elems[0], menuId, multiselectMenuIds);
  },

  show: function (elem, menuId, multiselectMenuIds) {
    $('#workarea').css('cursor', '');
    this.popupMenuButtons.buildPopupMenu(elem, menuId, multiselectMenuIds, this.$el);

    this.$el.find('.element-popupmenu li a:not([data-action=on_fontfamily])').click(() => {
      $('#sidebar-resize-button').removeClass('collapse-hidden', $('#sidebar-resize-button').is(':hidden'));
    });

    this.$el.find('a[data-action=on_fontfamily]').click(function () {
      $('#sidebar-resize-button').toggleClass('collapse-hidden', $(this).is('.active'));
    });

    this.$el.find('a[data-action=on_fontfamily] div').click((e) => {
      e.stopPropagation();
    });
  },

  hide: function () {
    this.canvas = this.canvas || INKIVE.Tool.getInstance().editor.canvas;

    if (this.canvas.runExtensions('getBleedValues', {}).manage) {
      return;
    }

    _.each($('.element-popupmenu'), _.bind(function (el) {
      const elemId = $(el).attr('data-element-id');
      const $elem = $('#svgcontent').find('#' + elemId);

      if ($elem.length && $elem.data('popupmenu')) {
        $elem.popupmenu('destroy');
      }
    }, this));

    $('.element, .subelement, .background rect, .background image, .main>rect, .main>path').each(function () {
      const $this = $(this);
      $this.data('popupmenu') && $this.popupmenu('destroy');
    });

    const fontMenu = $('#font-menu-list').addClass('hidden');

    fontMenu.children().length && fontMenu.appendTo(this.$el);

    this.$el.find('.element-popupmenu>div>ul').empty();
    this.$el.find('.element-popupmenu>div>ul').removeAttr('style');
    this.$el.find('.scroll-handler i').off('click');
    this.$el.find('.scroll-handler').hide();
    this.$el.find('.element-popupmenu').css('display', 'none');
    this.$el.find('.element-popupmenu').css('left', 0);
    this.$el.find('.root-popupmenu').css('display', 'flex');

    $('#sidebar-resize-button').removeClass('collapse-hidden');

    INKIVE.EditorFacade.trigger('popupmenu.hide');
  },

  refresh: function () {
    this.render(this.canvas.getSelectedElems());
  },

  removeElementEvent: function () {
    this.hide();
    this.canvas.runExtensions('clear', {});
    $('#sidebar-resize-button').removeClass('collapse-hidden');
  }
});
